import * as React from 'react';
const context = React.createContext({
    type: 'default',
});
export const SectionNotificationProvider = context.Provider;
export const SectionNotificationConsumer = context.Consumer;
//# sourceMappingURL=SectionNotificationContext.js.map